<ng-container *ngIf="booking || bookingId">
    <ng-container *ngIf="disableLink || !viewData; else withLink">
        <span [attr.data-test]="dataTest">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Buchung kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </span>
    </ng-container>
    <ng-template #withLink>
        <a *ngIf="resolvedBookingId as id; else bookingLinkWithoutRoute"
           (mousedown)="prepareNewTab($event)"
           (click)="click($event)"
           [attr.data-test]="dataTest"
           [attr.target]="openInNewTab ? '_blank' : null"
           [attr.rel]="openInNewTab ? 'noopener' : null"
           [bcmRouterLink]="['bookings', id]">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Buchung kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </a>
        <ng-template #bookingLinkWithoutRoute>
        <a (click)="click($event)"
           [attr.data-test]="dataTest"
           style="cursor: pointer;">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Buchung kann nicht identifiziert werden!">
                    <em>Keine Bezeichnung</em>
                </abbr>
            </ng-template>
        </a>
        </ng-template>
    </ng-template>
</ng-container>

